<template>
  <div>
    <el-dialog title="网卡管理" :visible="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="60%" @close="close()" :modal=false>
      <el-button type="primary" @click="add"
                 v-if="btnInList('idc_device_netcard','add')">新增</el-button>
      <span style="position:absolute; right:50px; top:50px;">
        <el-button size="mini" type="primary" @click="skip">跳转到当前IDC私有网络平面</el-button>
      </span>
      <el-table :data="tableData" style="margin-top: 10px">
        <el-table-column align="center" property="id" label="ID"></el-table-column>
        <el-table-column align="center" property="ipCodeStr" label="网卡对应IP"></el-table-column>
        <el-table-column align="center" property="netCardName" label="网卡名称"></el-table-column>
        <el-table-column align="center" property="netCardCode" label="网卡code"></el-table-column>
        <el-table-column align="center" property="operate" label="操作">
          <template v-slot="{row}">
            <el-button size="mini" type="primary" @click="editCard(row)"
                       v-if="btnInList('idc_device_netcard','edit')">编辑</el-button>
            <el-button size="mini" type="danger" @click="delCardConfirm(row.id)"
                       v-if="btnInList('idc_device_netcard','del')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
<!--    新增/编辑网卡信息-->
    <el-dialog :title="cardAddTitle" :visible="addInfo" :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="40%">
      <el-form label-position="left" style="margin-left: 25px" :model="form" ref="form" :rules="rules" label-width="85px">
        <el-form-item label="网卡名称" prop="netCardName" style="width: 320px">
          <el-input v-model="form.netCardName" placeholder="请输入内容" ></el-input>
        </el-form-item>
        <el-form-item label="网卡code" prop="netCardCode" style="width: 320px">
          <el-input v-model="form.netCardCode" placeholder="请点击获取网卡code"></el-input>
          <el-button type="primary" size="medium" @click="getCardCode()">获取网卡code</el-button>
        </el-form-item>
        <el-form-item label="IP类型" >
          <el-radio-group v-model="form.ipType" @change="ipTypeChange">
            <el-radio :label="2">内网IP</el-radio>
            <el-radio :label="1">外网IP</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="ipId" label="对应IP" >
          <el-select v-model="form.ipId" filterable placeholder="请选择对应ip"
                     style="width: 240px;margin-right: 10px;" @change="selectIp">
          <el-option v-for="(option, idx) in ipList"
                     :key="idx"
                     :label="option.ipStr + ' ' + option.message"
                     :value="option.id"
                     :disabled="!option.status || option.isSelect"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="saveCard()">确 定</el-button>
        <el-button @click="resetForm()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

  export default {
    name: "CardManager",
    data() {
      return {
        bindIdList:[],
        selectIpAttr:"",
        cardAddTitle:"",
        addInfo: false,
        tableData: [],
        form: {
          netCardName: "",
          netCardCode: "",
          ipId: null,
          ipType: 2
        },
        ipList: [],
        innerIpList: [],
        wanIpList: [],
        rules: {
          netCardName: [
            {required:true, message: '必填项', trigger: 'blur'}
          ],
          netCardCode: [
            {required:true, message: '必填项', trigger: 'blur'}
          ],
          ipId: [
            {required:true, message: '必填项', trigger: 'blur'}
          ],
        },
      }
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
      // 操作按钮是否可以显示
      btnInList() {
        return (name, childName) => {
          let btn = this.listOperations.filter(op => op.name.includes(name));
          if(btn && btn.length>0){
            if (!childName) {
              return btn.length > 0
            } else {
              return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
            }
          }
        }
      },
    },
    methods: {
      ...mapMutations(['getListOperations']),
      selectIp(e){
        this.ipList.forEach(item=>{
          if (e==item.id){
            this.selectIpAttr=item.ipAttr;
          }
        })
      },
      skip() {
        this.$router.push({
          path: 'privatenetplane',
          name: 'privatenetplane'
        })
      },
      close() {
        this.$emit('editCallback')
      },
      add() {
        this.id = null;
        this.cardAddTitle = "新增网卡信息";
        this.form.netCardName = "";
        this.form.netCardCode = "";
        this.form.ipId = "";
        this.form.ipType = 2;
        this.ipList = this.innerIpList;
        this.ipList.forEach(e=>{
          this.bindIdList.forEach(item=>{
            if(e.id==item && e.status){
              e.isSelect=true;
            }
          })
        })
        this.addInfo = true;
      },
      resetForm() {
        this.addInfo = false
      },
      editCard(item) {
        this.selectIpAttr=item.ipAttr;
        this.id = item.id;
        this.cardAddTitle = "编辑网卡信息";
        this.form.netCardName = item.netCardName;
        this.form.netCardCode = item.netCardCode;

        this.form.ipId = item.ipId;
        let _this = this;
        let ipArray = this.innerIpList.concat(this.wanIpList);
        for(let i=0; i < ipArray.length; i++){
          let obj = ipArray[i]

          if( obj.ipStr == item.ipCodeStr){
            _this.form.ipType = obj.ipType;
            break;
          }
        }
        if( _this.form.ipType == 2){
          _this.innerIpList.forEach( e => {
            if( e.ipStr == item.ipCodeStr){
              e.status = true;
              // e.message = "";
            }
          })
          _this.ipList = _this.innerIpList;
        }else {
          _this.wanIpList.forEach( e => {
            if( e.ipStr == item.ipCodeStr){
              e.status = true;
              // e.message = "";
            }
          })
          _this.ipList = _this.wanIpList;
        }
        this.ipList.forEach(e=>{
          if (item.ipId==e.id){
            e.isSelect=false;
          }else {
            this.bindIdList.forEach(q=>{
              if(e.id==q && e.status){
                e.isSelect=true;
              }
            })
          }
        })
        this.addInfo = true
      },
      ipTypeChange(){
        this.form.ipId = "";
        if(this.form.ipType == 2){
          this.ipList = this.innerIpList;
        }else{
          this.ipList = this.wanIpList;
        }
      },
      getCardCode(){
        let _this = this;
        if(!this.form.netCardName){
          _this.$message({showClose: true, message: '请输入网卡名称', type: 'warning'})
          return
        }
        let param = {
          netCardName: this.form.netCardName,
          deviceName: this.deviceInfo.deviceName
        }
        const loading = this.$loading({
          lock: true,
          text: '获取中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55,55, 0.4)'
        });

        this.$axios.post(this.baseUrl3 + 'management3/netcard/code', param)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.form.netCardCode = data
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            setTimeout(() => {
              loading.close();
            }, 1000);
            // loading.close();
          })
      },
      saveCard() {
        this.$refs.form.validate(valid => {
          if (valid) {
            let data = {
              netCardName: this.form.netCardName,
              netCardCode: this.form.netCardCode,
              id: this.id,
              deviceId: this.deviceInfo.id,
              ipAttr:this.selectIpAttr
            };
            if(this.form.ipId){
              data.ipId = this.form.ipId
            }else {
              data.ipId = null
            }
            const loading = this.$loading({
              lock: true,
              text: '加载中...',
              // spinner: 'el-icon-loading',
              background: 'rgba(55,55,55, 0.4)'
            });
            let _this = this;
            this.$axios.post(this.baseUrl3 + 'management3/netcard/update', data)
              .then(({data: {msg, data, code}}) => {
                if (code == 20000) {
                  _this.initNetCardList();
                  _this.getIpList();
                  _this.resetForm(true);
                } else {
                  _this.$message({showClose: true, message: msg, type: 'error'})
                  console.log(msg)
                }
                loading.close();
              })
              .catch(err => {
                console.log(err);
                setTimeout(() => {
                  loading.close();
                }, 1000);
              })
          }
        })
      },
      delCardConfirm(id){
        this.$confirm('您确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delCard(id)
        }).catch(() => {

        });
      },
      delCard(id) {
        let data = {
          id: id
        };
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netcard/del', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.initNetCardList();
              _this.getIpList();
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initNetCardList(){
        let data = {
          deviceId: this.deviceInfo.id,
        }
        this.tableData = [];
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netcard/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if (data && data.length>0){
                _this.tableData = data;
                _this.bindIdList=[];
                data.forEach(e=>{
                  _this.bindIdList.push(e.ipId);
                })
              }else {
                _this.tableData =[]
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getIpList() {
        let _this = this;
        let data = {
          idcId: _this.idcId
        }
        _this.innerIpList = []
        _this.wanIpList = []
        this.$axios.post(this.baseUrl3 + 'management3/netcardbind/iplist', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              data.forEach( e =>{
                if( e.ipType == 2){
                  _this.innerIpList.push(e)
                }else {
                  _this.wanIpList.push(e)
                }
              })
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getIpSelect(level) {
        let _this = this;
        let pid = null;
        if (level == 0) {
          pid = pid;
        }
        let data = {
          parentACode: pid
        }
        this.$axios.post(this.baseUrl3 + 'management3/netip/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.ip = data;
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
    props: {
      visible: {
        type: Boolean
      },
      deviceInfo: {
        type: Object
      },
      idcId: {
        type: Number
      },
    },
    created() {
      this.getListOperations('idclist');
      if (!this.currentMenu) {
        return
      }
      this.initNetCardList();
      this.getIpList();
    }
  }
</script>

<style >
  .el-loading-spinner {
    background-image:url('../../assets/loading1.svg');
    background-size:63px 100px;
    background-repeat: no-repeat;
    height:30%;
    background-position:center;
    top:200px;
  }
  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }
</style>
